var spinData = {
  name: "spin",
  data: [{
    size: 50,
    type: "circle",
    circleColorGradient: ["#87B4F5", "#3889FF"],
    fillColor: "rgba(0,0,0,0)"
  }]
};
export default spinData;